import { Component } from '@theme/component';

/** Progressive table of contents; source article markup and existing IDs stay intact. */
class SDArticleReading extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.#build();
  }

  updatedCallback() {
    super.updatedCallback();
    this.#build();
  }

  #build() {
    const body = this.querySelector('[data-reading-body]');
    const rail = this.querySelector('[data-reading-toc]');
    const list = this.querySelector('[data-reading-links]');
    if (!body || !rail || !list) return;
    const headings = [...body.querySelectorAll('.blog-post-content h2')]
      .filter((heading) => heading.textContent.trim() && !heading.closest('[hidden], template'));
    const fragment = document.createDocumentFragment();
    headings.forEach((heading, index) => {
      if (!heading.id) {
        const base = `sd-reading-${this.dataset.sectionId}-${index + 1}`;
        let id = base;
        let suffix = 0;
        while (document.getElementById(id)) id = `${base}-${++suffix}`;
        heading.id = id;
      }
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${encodeURIComponent(heading.id)}`;
      link.textContent = heading.textContent.trim();
      item.append(link);
      fragment.append(item);
    });
    list.replaceChildren(fragment);
    rail.hidden = headings.length === 0;
    this.classList.toggle('sd-article-reading--with-toc', headings.length > 0);
  }
}

if (!customElements.get('sd-article-reading')) {
  customElements.define('sd-article-reading', SDArticleReading);
}
